export default __webpack_public_path__ + "static/media/photo-1524503033411-c9566986fc8f.4850ec84.png";